import React from 'react';

import { LoginPage } from '@lumapps/login/components/LoginPage';
import { SendEmailForm } from '@lumapps/login/components/SendEmailForm';
import type { StepProps } from '@lumapps/lumx-layouts/types';
import { useTranslate } from '@lumapps/translations';

import { SEND_MAGIC_LINK_FORM_ID, TITLE_ID } from '../../constants';
import { MAGIC_LINK } from '../../keys';

/**  SendEmailFormStep: Component which render the step of send email.
 */
export const SendEmailFormStep: React.FC<StepProps> = ({ backButton, ...props }) => {
    const { translateKey } = useTranslate();

    return (
        <LoginPage before={backButton} title={translateKey(MAGIC_LINK.SIGN_IN_WITH_EMAIL)} displayPoweredBy>
            <SendEmailForm
                formId={SEND_MAGIC_LINK_FORM_ID}
                titleId={TITLE_ID}
                isMagicLink
                {...props}
                buttonText={translateKey(MAGIC_LINK.SEND_MAGIC_LINK)}
            />
        </LoginPage>
    );
};
